import './App.css';
import profile from './images/avatar.jpg';
import dog1 from './images/dog-image-1.jpg';
import dog2 from './images/dog-image-2.jpg';
import dog3 from './images/dog-image-3.jpg';


function App() {
  return (
   
    <div className="h-screen main relative overflow-hidden font-sans w-full bg-[#FAFAFA]">
      {/* this is heading and supporting line */}
      <h1 className='text-[#2E1A3F]  absolute top-[18rem] right-[28rem] text-4xl font-medium'>Simple Booking</h1>
      <p className='absolute   top-[22rem] leading-8 text-lg right-[14rem] text-[rgba(0,0,0,0.3)]'>Stay in touch with our dog walkers through the chat <br /> interface.
        This makes it easy to discuss arrangements and <br /> make bookings.Once
        the walk has been completed you can <br /> rate your walker and book again all
        through the chat.
      </p>
      {/* Outside rectingle */}
      <div id='tri' className='bg-gradient-to-b absolute   left-[-2rem] h-[40rem] rounded-b-[10rem] w-[20rem] from-[#C640FF] to-[#933BFF]'>
      </div>
      <div className='bg-gradient-to-b absolute right-[-2rem] opacity-[0.02] h-[40rem] bottom-0 rounded-t-[10rem] w-[20rem] from-[#C640FF] to-[#933BFF]'>
      </div>
      {/* this is phone div */}
      <div className='bg-[#F5F3F8] border-white border-[6px]  h-[26rem] top-[10rem] left-[15rem] rounded-2xl w-[14rem] relative '>

        <div className='bg-[#FFFFFF] z-10 absolute h-[1rem] top-[-0.40rem] left-[1.50rem] w-[10rem] rounded-full '>
        </div>
        <div className=' absolute bg-gradient-to-r from-[#8C3AFE] to-[#DF43FF] rounded-b-md rounded-t-lg top-0 left-0 w-full h-12'>
          <img src={profile} className='h-5 top-[16px] absolute left-[24px] border-white border-[1px] rounded-full' alt='profile' />
          <p className='text-lg absolute left-[5px] top-[11px] text-white'>&#x2B05;</p>
          <h3 className='text-[12px] text-white absolute left-[54px] top-[12px]'>Samuel Green</h3>
          <p className='text-[8px] absolute text-[rgba(255,255,255,0.3)] left-[54px] top-[26px]'>Available to Work</p>
          <p className='text-white absolute right-2 top-[12px]'>&#8942;</p>
        </div>

        <div className='bg-[#E5DDEA] absolute left-1 rounded-lg top-[3.50rem] h-10 w-32'>
          <p className='text-[8px]  pl-2 pt-2'>That sounds great,I'd be <br /> happy with that.</p>
        </div>
        <div className='bg-[#E5DDEA] absolute left-1 rounded-lg top-[6.50rem] h-10 w-32'>
          <p className='text-[8px]  pl-2 pt-2'>Could you send over some pictures of your dog , please?</p>
        </div>
        <img src={dog1} alt='dog1' className='h-10 rounded-lg  top-[10rem] absolute right-[6.50rem]' />
        <img src={dog2} alt='dog2' className='h-10 rounded-lg  top-[10rem] absolute right-14' />
        <img src={dog3} alt='dog3' className='h-10 rounded-lg  top-[10rem] absolute right-2' />

        {/* this is message div */}

        <div className='h-[2rem] absolute rounded-full left-[8px] bottom-[.50rem] pl-5 pt-[7px] bg-[#FFFFFF]  w-[12rem]'>
          <p className='text-[12px]'>Type a message...</p>
          <div className='bg-[#3A254E]   absolute top-[.30rem] right-[.20rem] rounded-full h-[1.40rem] w-[1.40rem]'>
            <p className='text-white text-center   font-semibold '>&#x1F3F9;</p>
          </div>
        </div>
      </div>

    </div>

  );
}

export default App;
